module.exports = __webpack_public_path__ + "img/arrow_right.3270daab.svg";